import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import { E製造原価科目未使用フラグ, Eフェーズ種別 } from '@/openapi/enum';
import { データApi, 部門Api, 部門ListItemResponse } from '@/openapi/user';

import C償却List from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/償却List/償却List.vue';
import C減価償却Total from '@/entries/user/pages/authorized/事業所/計画書/分析計画/償却/components/減価償却Total/減価償却Total.vue';
import C部門Select from '@/components/部門Select/部門Select.vue';
import C決算期TableHeader from '@/components/決算期TableHeader/決算期TableHeader.vue';
import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 償却ListMixin from '@/entries/user/mixins/償却ListMixin';
import 償却保存Mixin from '@/entries/user/mixins/償却保存Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import { 償却EditItem, 償却ListItem, 項目別Values } from '@/classes/service/分析計画/償却Type';

export default mixins(RoutesMixin, 償却ListMixin, 償却保存Mixin).extend({
  name: 'P償却予測額',

  components: {
    C償却List,
    C減価償却Total,
    C部門Select,
    C決算期TableHeader,
    MoneyUnitSelect,
  },

  data(): {
    isSimple: boolean;
    部門s: 部門ListItemResponse[];
    部門割合DialogVisible: boolean;
    selectedItem: 償却ListItem | null;
    editItem: {
      部門Pk: number;
      販管費割合: number;
    };
  } {
    return {
      isSimple: false,
      部門s: [],
      部門割合DialogVisible: false,
      selectedItem: null,
      editItem: {
        部門Pk: 0,
        販管費割合: 100,
      },
    };
  },

  async created(): Promise<void> {
    // 部門を取得
    const response = await UserApiUtility.ogApi(部門Api).list部門(this.事業所.pk);
    this.部門s = response.data;

    // 初期設定
    this.initialize償却Service(Eフェーズ種別.計画フェーズ, '償却予測額', this.部門s);
  },

  computed: {
    is製造原価科目(): boolean {
      return this.事業所.c製造原価科目未使用フラグ === E製造原価科目未使用フラグ.使用する;
    },
    集計表blankColspan(): number {
      return this.is製造原価科目 ? 11 : 10;
    },
    減価償却blankColspan(): number {
      return this.isSimple ? 1 : this.集計表blankColspan + 2;
    },
    集計表s(): { label: string; items: 項目別Values[]; blankRowspan: number }[] {
      if (this.v償却 === null || this.v償却.total.償却予測額 === undefined) return [];
      return [
        {
          label: '部門別減価償却費',
          items: this.v償却.total.償却予測額.部門別減価償却s,
          blankRowspan: this.v償却.total.償却予測額.部門別減価償却s.length,
        },
        {
          label: '科目別期末簿価',
          items: this.v償却.total.償却予測額.科目別期末簿価s,
          blankRowspan: this.v償却.total.償却予測額.科目別期末簿価s.length,
        },
      ];
    },
  },

  methods: {
    open部門割合Dialog(item: 償却ListItem): void {
      // 選択中データの保持
      this.selectedItem = item;
      // 編集用オブジェクトに必要な値のみコピー
      this.editItem.部門Pk = item.部門Pk!;
      this.editItem.販管費割合 = item.販管費割合!;
      // 編集ダイアログオープン
      this.部門割合DialogVisible = true;
    },
    async save(): Promise<void> {
      if (this.selectedItem === null) return;
      const {
        データpk,
        番号,
        フェーズ種別,
        科目名,
        償却率,
        定率法償却,
        再計算前期末簿価,
        償却不足額,
        部門名,
        年次計算減価償却Map,
        ...cデータ償却org
      } = this.selectedItem;

      const cデータ償却: 償却EditItem = _.cloneDeep(cデータ償却org);

      // 編集値のセット
      cデータ償却.部門Pk = this.editItem.部門Pk;
      cデータ償却.販管費割合 = this.editItem.販管費割合;

      // 表示用の年次計算減価償却Mapから、DB格納用の減価償却sを設定
      cデータ償却.減価償却s = this.create減価償却s(年次計算減価償却Map);

      // DB更新
      const request = this.create償却データRequest(番号!, フェーズ種別!, cデータ償却);
      await UserApiUtility.ogApi(データApi).updateデータ(データpk!, request);
      this.load償却List();
      this.部門割合DialogVisible = false;
    },
  },
});
